import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';

export interface AppConfig {
  apiUrl: string;
  contractUrl: string;
  sisUrl: string;
  savatarUrl: string;
  keycloak: { url: string; realm: string; clientId: string };
  matomo: { config: { trackerUrl: string; siteId: number; disabled?: boolean } };
  sentry?: {
    enabled: boolean;
    dsn: string;
    environment: string;
    tracesSampleRate: number;
    replaysSessionSampleRate: number;
    replaysOnErrorSampleRate: number;
    tracePropagationTargets: string | string[];
  };
}

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  private readonly http = inject(HttpClient);

  private appConfig: AppConfig;

  async loadAppConfig(): Promise<AppConfig> {
    const data = await firstValueFrom(this.http.get<AppConfig>('/assets/environment.json'));
    this.appConfig = data;
    return data;
  }

  get apiUrl() {
    if (!this.appConfig) {
      throw new Error('Config file not loaded!');
    }
    return this.appConfig.apiUrl;
  }

  get contractUrl() {
    if (!this.appConfig) {
      throw new Error('Config file not loaded!');
    }
    return this.appConfig.contractUrl;
  }

  get sisUrl() {
    if (!this.appConfig) {
      throw new Error('Config file not loaded!');
    }
    return this.appConfig.sisUrl;
  }

  get savatarUrl() {
    if (!this.appConfig) {
      throw new Error('Config file not loaded!');
    }
    return this.appConfig.savatarUrl;
  }

  get matomo() {
    if (!this.appConfig) {
      throw new Error('Config file not loaded!');
    }
    return this.appConfig.matomo;
  }
}
